import { useTranslation } from 'react-i18next';
import { buildNetworkScanGuideUrl } from '../config/networkScan';
import { IndustryType, useIndustryType } from './useIndustryType';

/**
 * URL of the static network scan guide (IBM-1039) in the user's UI language
 * and with the brand accent of their industry type — the same choice as
 * `DynamicBrandTheming`. See `src/config/networkScan.ts`.
 */
export const useNetworkScanGuideUrl = (options: { embed?: boolean } = {}): string => {
    const { i18n } = useTranslation();
    const industryType = useIndustryType();
    return buildNetworkScanGuideUrl({
        lng: i18n.resolvedLanguage ?? i18n.language,
        brand: industryType === IndustryType.SEMICONDUCTOR ? 'argos' : 'busch',
        embed: options.embed,
    });
};
